/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Tracking_Limit_DescInputs */

const en_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to track unlimited jobs and unlock AI-powered resume tailoring.`)
};

const de_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade, um unbegrenzt Jobs zu verfolgen und KI-gestütztes Lebenslauf-Tailoring freizuschalten.`)
};

const fr_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe au niveau supérieur pour suivre des emplois illimités et débloquer l'adaptation de CV par IA.`)
};

const es_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora para rastrear empleos ilimitados y desbloquear la adaptación de CV con IA.`)
};

const it_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna per monitorare lavori illimitati e sbloccare l'adattamento del CV con IA.`)
};

const nl_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade om onbeperkt vacatures te volgen en AI-aangedreven CV-aanpassing te ontgrendelen.`)
};

const pl_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz, aby śledzić nieograniczoną liczbę ofert i odblokować dostosowywanie CV z AI.`)
};

const fi_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä seurataksesi rajattomasti työpaikkoja ja avataksesi tekoälyn mukauttaman ansioluettelon.`)
};

const da_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader for at spore ubegrænsede jobs og låse op for AI-drevet CV-tilpasning.`)
};

const sv_job_tracking_limit_desc = /** @type {(inputs: Job_Tracking_Limit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera för att spåra obegränsade jobb och låsa upp AI-driven CV-anpassning.`)
};

/**
* | output |
* | --- |
* | "Upgrade to track unlimited jobs and unlock AI-powered resume tailoring." |
*
* @param {Job_Tracking_Limit_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const job_tracking_limit_desc = /** @type {((inputs?: Job_Tracking_Limit_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Tracking_Limit_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_tracking_limit_desc(inputs)
	if (locale === "fr") return fr_job_tracking_limit_desc(inputs)
	if (locale === "es") return es_job_tracking_limit_desc(inputs)
	if (locale === "it") return it_job_tracking_limit_desc(inputs)
	if (locale === "nl") return nl_job_tracking_limit_desc(inputs)
	if (locale === "pl") return pl_job_tracking_limit_desc(inputs)
	if (locale === "fi") return fi_job_tracking_limit_desc(inputs)
	if (locale === "da") return da_job_tracking_limit_desc(inputs)
	if (locale === "sv") return sv_job_tracking_limit_desc(inputs)
	return en_job_tracking_limit_desc(inputs)
});